module.exports = __webpack_public_path__ + "./fonts/MontserratAlternates-Bold.ttf";